<template>
  <div class="table-container">
    <div class="header">
      <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新增</el-button>
    </div>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>

      <el-table-column prop="title" label="问题" min-width="200"></el-table-column>

      <el-table-column prop="content" label="解答" min-width="300">
        <template slot-scope="scope" label-width="300">
          <pre style="max-width: 700px;white-space: pre-wrap;overflow-wrap: break-word;margin: 0 auto;">{{
              scope.row.content
            }}</pre>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="300" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            修改
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="currentPage"
          :page-sizes="[8,16,24,32]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="问题" prop="title">
          <el-input v-model="form.title" placeholder="请输入问题"></el-input>
        </el-form-item>
        <el-form-item label="解答" prop="content">
          <el-input type="textarea" :rows="4" v-model="form.content" placeholder="请输入解答"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 8,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增',
      form: {
        id: '',
        title: '',
        content: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入问题', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入解答', trigger: 'blur'}
        ]
      },
      editIndex: -1
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$api.queryFAQ({
        page: this.currentPage,
        nums: this.pageSize,
      }).then(res => {
        if (res.code == 200) {
          const mockData = res.data.list;
          this.tableData = mockData.map((item, index) => ({
            ...item,
            index: index + 1
          }));
          this.total = res.data.total;
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增';
      this.form = {
        id: '',
        title: '',
        content: ''
      };
      this.dialogVisible = true;
      this.editIndex = -1;
    },
    handleEdit(index, row) {
      this.dialogTitle = '修改';
      this.form = {
        id: row.id,
        title: row.title,
        content: row.content
      };
      this.dialogVisible = true;
      this.editIndex = index;
    },
    handleDelete(index, row) {
      this.$confirm('确定要删除这条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.deleteFAQ({id: row.id}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.fetchData();

          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.editIndex === -1) {
            // 新增
            this.$api.addFAQ({
              title: this.form.title,
              content: this.form.content
            }).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.fetchData();
              }
            });
          } else {
            // 修改
            this.$api.updateFAQ({
              id: this.form.id,
              title: this.form.title,
              content: this.form.content
            }).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.fetchData();
              }
            });
          }
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    }
  }
}
</script>

<style scoped>
.table-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header {
  margin-bottom: 20px;
}

.block {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
}
</style>